import BidderRegister from "./BidderRegister";
import ShowAuctions from "./ShowAuctions";
import Reciept from "./Reciept";
import RecieptForm from "./RecieptForm";
import ContactUs from "./contactUs";
import AboutUs from "./AboutUs";
import RegistrationForm from "./RegistrationsForm";


export {Reciept,ShowAuctions,BidderRegister,RecieptForm,ContactUs,AboutUs,RegistrationForm}